import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const NavbarContainer = styled.nav`
    background-color: #026aa7;
    padding: 0 16px;
    color: white;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 1000;
    border-bottom: 1px solid #3B444C;
    height: 41px;
`;

export const Logo = styled(Link)`
    color: white;
    text-decoration: none;
    font-size: 24px;
    font-weight: bold;
    margin-right: auto;
    transition: color 0.2s ease;

    &:hover {
        color: #579DFF;
    }
`;

export const NavLinks = styled.div`
    display: flex;
    gap: 16px;
`;

export const NavLink = styled(Link)`
    color: white;
    text-decoration: none;
    padding: 8px;
    border-radius: 3px;
    transition: all 0.2s ease;

    &:hover {
        background: rgba(255, 255, 255, 0.1);
        color: #579DFF;
    }
`;

export const UserSection = styled.div`
    position: relative;
`;

export const UserButton = styled.button`
    background: none;
    border: none;
    padding: 4px;
    cursor: pointer;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;

    &:hover {
        background: rgba(255, 255, 255, 0.1);
        transform: scale(1.05);
    }
`;

export const UserAvatar = styled.img`
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: ${props => props.src ? 'none' : '#3B444C'};
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 14px;
    text-transform: uppercase;
    border: 2px solid transparent;
    transition: all 0.2s ease;

    ${UserButton}:hover & {
        border-color: rgba(255, 255, 255, 0.1);
    }
`;

export const UserMenu = styled.div`
    position: absolute;
    top: 100%;
    right: 0;
    margin-top: 8px;
    background: #282E33;
    border-radius: 3px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
    width: 280px;
    border: 1px solid #3B444C;
    z-index: 200;
    
    &::before {
        content: '';
        position: absolute;
        top: -4px;
        right: 12px;
        width: 8px;
        height: 8px;
        background: #282E33;
        transform: rotate(45deg);
        border-left: 1px solid #3B444C;
        border-top: 1px solid #3B444C;
    }
`;

export const MenuItem = styled.button`
    width: 100%;
    padding: 8px 12px;
    text-align: left;
    background: none;
    border: none;
    color: ${props => props.disabled ? '#8C9BAB' : '#B6C2CF'};
    cursor: ${props => props.disabled ? 'default' : 'pointer'};
    font-size: 14px;
    display: block;
    transition: all 0.2s ease;

    &:hover {
        background: ${props => props.disabled ? 'none' : '#3B444C'};
    }

    strong {
        display: block;
        color: #B6C2CF;
        margin-top: 2px;
    }

    &:not(:last-child) {
        border-bottom: 1px solid #3B444C;
    }
`;

export const AddMenuButton = styled.button`
    background: transparent;
    border: none;
    color: white;
    padding: 8px;
    border-radius: 3px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;

    &:hover {
        background: rgba(255, 255, 255, 0.1);
    }

    svg { // Ensure SVG inherits color, or set explicitly if PlusIcon doesn't handle it
        fill: currentColor;
    }
`;

export const AddMenu = styled.div.attrs(props => ({
    // The style prop will provide left or right, so remove them from here
    // menuAlignment prop will be used for the arrow
}))`
    position: absolute;
    top: calc(100% + 8px); // Position below the button with a small gap
    /* left: 0; */ /* Removed, will be set by inline style */
    background: #282E33;
    border-radius: 3px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
    width: 220px; // As per instruction
    border: 1px solid #3B444C;
    z-index: 200;

    &::before {
        content: '';
        position: absolute;
        top: -5px;
        width: 10px;
        height: 10px;
        background: #282E33;
        transform: rotate(45deg);
        border-left: 1px solid #3B444C;
        border-top: 1px solid #3B444C;

        ${props => props.style?.menuAlignment === 'right' ?
            'right: 15px;' :
            'left: 15px;'
        }
    }
`;

export const AddMenuItem = styled.button`
    width: 100%;
    padding: 10px 15px; // Slightly more padding than MenuItem
    text-align: left;
    background: none;
    border: none;
    color: #B6C2CF; // Same as MenuItem
    cursor: pointer;
    font-size: 14px;
    display: flex; // Changed to flex for icon alignment
    align-items: center; // Align items vertically
    transition: all 0.2s ease;

    &:hover {
        background: #3B444C; // Same as MenuItem hover
        color: #FFFFFF; // Brighter text on hover
    }

    &:not(:last-child) {
        border-bottom: 1px solid #3B444C; // Same as MenuItem
    }

    svg { // Style for icons within menu items
        margin-right: 10px; // Space between icon and text
        // Colors are set directly on the icon components, so no need to set color here
    }
`;